import { NewOrderType, TNewOrderType } from "@/entities/new-order";

export const getTotalCurrentTypeName = (orderType: TNewOrderType) => {
  //функция, которая возвращает правильное отображение типа кампании
  const typeNames = {
    [NewOrderType.install]: "installs",
    [NewOrderType.rate]: "rates",
    [NewOrderType.install_bp]: "installs",
    [NewOrderType.install_with_views]: "installs",
    [NewOrderType.review]: "reviews",
  };

  return typeNames[orderType];
};
